import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/hooks/store/useAuth";

export const useIsGuest = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();

  useEffect(() => {
    switch (authState) {
      case "authenticated":
        navigate("/");
        break;
      case "unverified":
        navigate("/verify");
        break;
      default:
        break;
    }
  }, [navigate, authState]);
};
